import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	getAccessToken,
	getExpireTime,
	getRememberMe,
} from '../Utils/AuthUtil';

const publicRoutes = ['/home', '/login', '/createAccount', '/reset/role'];

function SessionGuard() {
	const navigate = useNavigate();

	useEffect(() => {
		const expireTime = getExpireTime();
		const rememberMe = parseInt(getRememberMe() || '0', 10);

		if (!expireTime || isNaN(rememberMe)) {
			const isPublicOnly = publicRoutes.some(route =>
				location.pathname.startsWith(route),
			);
			if (!getAccessToken() && !isPublicOnly) {
				navigate('/home');
			}

			return;
		}

		if (expireTime !== null && (rememberMe === 0 || rememberMe === 2)) {
			const now = Date.now();
			const expireTimestamp = parseInt(expireTime, 10);

			if (!isNaN(expireTimestamp) && now > expireTimestamp) {
				localStorage.clear();
				navigate('/home');
			}
		}
	}, [navigate]);

	return null;
}

export default SessionGuard;
